import { DateTime } from "b2b/renderers";

export const cislo = () => ({
  id: "cislo",
  label: "b2b.smlouvy-grid-columns.cislo.label",
  path: "cislo"
});

export const popis = () => ({
  id: "popis",
  label: "b2b.smlouvy-grid-columns.popis.label",
  path: "popis"
});

export const fixniMZO = () => ({
  id: "fixniMZOLabel",
  label: "b2b.smlouvy-grid-columns.fixniMZO.label",
  path: "fixMo"
});

export const fixniVZO = () => ({
  id: "fixniVZOLabel",
  label: "b2b.smlouvy-grid-columns.fixniVZO.label",
  path: "fixVo"
});

export const platnostOd = () => ({
  id: "platnostOdLabel",
  label: "b2b.smlouvy-grid-columns.platnostOd.label",
  path: "platnostOd",
  renderer: DateTime
});

export const platnostDo = () => ({
  id: "platnostDoLabel",
  label: "b2b.smlouvy-grid-columns.platnostDo.label",
  path: "platnostDo",
  renderer: DateTime
});
